<template>
  <div class="overflow-scroll-y">
    <div class="card">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>登録完了</h2>
          <p>
            yagiofferへのご登録ありがとうございました。<br />
            登録完了メールをお送りいたしましたのでご確認ください。
          </p>
          <div class="complete_block">
            <div class="cb-01">
              <h2 class="cb-h2">
                オファーがメール・<br />マイページで確認できます！
              </h2>

              <figure class="cb-figure">
                <img src="/static/renew3_img/yagioffer_complete_img.png" />
              </figure>
            </div>

            <!--転職用-->
            <div
              class="renew2_flex renew2_sp_flex cb-linkbox"
              v-if="formatId == 'career'"
            >
              <a
                href="/format/shokumukeirekisho/edit/profile"
                class="cb-linkitem cb-syokureki"
                >職歴書をつくる</a
              >
              <a href="/mypage/yagioffer" class="cb-linkitem cb-mypage"
                >マイページを見る</a
              >
            </div>
            <!--新卒用-->
            <div class="share_block" v-if="formatId == 'new'">
              <div class="cb-linkbox">
                <a href="/mypage/yagioffer" class="cb-linkitem cb-mypage"
                  >マイページを見る</a
                >
              </div>

              <h2>友だちにもシェア</h2>
              <div class="renew2_flex renew2_sp_flex yagioffe-share">
                <a
                  href="http://www.facebook.com/share.php?u=https://portal.yagish.jp/career_yagioffer/"
                  target="_blank"
                  class="share-btn"
                >
                  <img
                    src="/static/renew2_img/yagioffer_img/share01.png"
                    alt="Facebookシェア"
                  />
                </a>
                <a
                  href="https://twiter.com/share?url=https://portal.yagish.jp/career_yagioffer/"
                  target="_blank"
                  class="share-btn"
                >
                  <img
                    src="/static/renew2_img/yagioffer_img/share02.png"
                    alt="Xシェア"
                  />
                </a>
                <a
                  href="https://social-plugins.line.me/lineit/share?url=https://portal.yagish.jp/career_yagioffer/"
                  target="_blank"
                  class="share-btn"
                >
                  <img
                    src="/static/renew2_img/yagioffer_img/share04.png"
                    alt="LINEシェア"
                  />
                </a>
                <a
                  href="javascript:navigator.clipboard.writeText('https://portal.yagish.jp/career_yagioffer/');alert('URLをコピーしました')"
                  class="share-btn"
                >
                  <img
                    src="/static/renew2_img/yagioffer_img/share05.png"
                    alt="URLコピー"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="complete_block" v-if="false">
            <h2>yagiofferに登録したら…</h2>
            <div class="renew2_sp_flex yagioffer-flow">
              <img
                src="/static/renew2_img/yagioffer_img/offer01.png"
                alt="100ポイントが付与されます！"
                class="yagioffer-img"
              />
              <img
                src="/static/renew2_img/yagioffer_img/offer02.png"
                alt="届いたオファーを確認してチャットで連絡！"
                class="yagioffer-img"
              />
            </div>
            <p class="yagioffer-h3">届いたオファーを確認してチャットで連絡！</p>
            <div class="share_block">
              <p>＼yagiofferを友だちにシェア／</p>
              <div class="renew2_flex renew2_sp_flex yagioffe-share">
                <a
                  :href="facebookPortalUrl"
                  rel="nofollow noopener"
                  class="share-btn"
                  target="_blank"
                  ><img
                    src="/static/renew2_img/yagioffer_img/share01.png"
                    alt="Facebookシェア"
                /></a>
                <a :href="twPortalUrl" class="share-btn" target="_blank"
                  ><img
                    src="/static/renew2_img/yagioffer_img/share02.png"
                    alt="Xシェア"
                /></a>
                <!--<a href="" class="share-btn" target="_blank"><img src="https://placehold.jp/100x100.png" alt="Instagramシェア"></a>-->
                <a
                  href="https://social-plugins.line.me/lineit/share?url=https://portal.yagish.jp/career_yagioffer/"
                  class="share-btn"
                  target="_blank"
                  ><img
                    src="/static/renew2_img/yagioffer_img/share04.png"
                    alt="LINEシェア"
                /></a>
                <a
                  href="javascript:navigator.clipboard.writeText('https://portal.yagish.jp/career_yagioffer/');alert('URLをコピーしました')"
                  class="share-btn"
                  ><img
                    src="/static/renew2_img/yagioffer_img/share05.png"
                    alt="URLコピー"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card .complete_block .cb-01 {
  background: #76ca80;
  border-radius: 10px;
  padding: 20px 20px 0;
  margin-top: 20px;
}

.card .complete_block .cb-h2 {
  text-align: center;
  color: #fff;
  line-height: 1.4;
}

.card .complete_block .cb-figure {
  margin: 0;
  text-align: center;
  margin-top: 15px;
}

.card .complete_block .cb-figure img {
  width: 255px;
}

.card .complete_block .cb-linkbox {
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
}

.card .complete_block .cb-linkitem {
  position: relative;
  width: calc(100% / 2 - 5px);
  text-align: center;
  background: #e95b10;
  border-radius: 50px;
  color: #fff;
  font-weight: bold;
  padding: 20px 0;
  line-height: 0;
}

.card .complete_block .cb-linkitem::after {
  position: absolute;
  content: '';
  width: 7px;
  height: 7px;
  border: 0;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  transform: rotate(-45deg);
  top: 0;
  right: 8px;
  bottom: 0;
  margin: auto;
}

.card .complete_block .cb-mypage {
  background: #e3165c;
}

.card .complete_block .share_block {
  margin-top: 20px;
}

.card .complete_block .share_block .cb-linkitem {
  display: block;
  width: 100%;
}

.card .complete_block .yagioffe-share {
  justify-content: center;
  margin-top: 5px;
}

.card .complete_block .share-btn {
  width: 50px;
  margin-left: 10px;
}

.card .complete_block .share-btn:first-child {
  margin-left: 0;
}
</style>

<script setup lang="ts">
const props = defineProps<{
  formatId?: string
  isSendYagiPostEnabled?: boolean
  isSendYagiEmailEnabled?: boolean
  mailPdfEnabled?: boolean
  downloadPdfEnabled?: boolean
  downloadActiveCollapses?: unknown[]
}>()

const facebookPortalUrl =
  'http://www.facebook.com/share.php?u=https://portal.yagish.jp/career_yagioffer/'
const twPortalUrl =
  'https://twiter.com/share?url=https://portal.yagish.jp/career_yagioffer/'

console.error(props.formatId)
</script>
